import { useCallback, useEffect, useMemo, useState } from "react";
import { config } from "../../config/config";
import { apiList, invokeApi } from "../../services/apiServices";
import { useDebounce } from "./useDebounce";
import { useParams } from "react-router-dom";

const useFetch = () => {
    const sessionValue = sessionStorage.getItem('lead_flag');
    const leadFlag = sessionValue ? sessionValue : 'Unknown';

    const [loading, setLoading] = useState(false);
    const [collegeData, setCollegeData] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [searchDistrictValue, setSearchDistrictValue] = useState("");
    const [areas, setCollegeAreas] = useState([]);
    const [allTopCollege, setAllTopCollege] = useState([]);
    const [allTopCollegeOne, setAllTopCollegeOne] = useState([]);
    const [allTopCollegeTypes, setAllTopCollegeType] = useState([]);
    const [selectedCollegeType, setSelectedCollegeType] = useState("");
    const [allTopCourse, setAllTopCourse] = useState([]);
    const [filteredDistricts, setFilteredDistricts] = useState([]);
    const [district, setDistrict] = useState([]);
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");

    const [course, setCourse] = useState("Select Course");
    const [qualification, setQualification] = useState("");
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [submitClicked, setSubmitClicked] = useState(false);
    const { ogUrl } = useParams();
    const [collegeInfo, setCollegeInfo] = useState({});
    const [collegeAmenities, setCollegeAmenities] = useState([]);
    const [collegePlacement, setCollegePlacement] = useState([]);
    const [collegeCourse, setCollegeCourse] = useState([]);
    const [collegeGallery, setCollegeGallery] = useState([]);
    const [exploreNearColleges, setExploreNearColleges] = useState([]);
    const [districtsFetched, setDistrictsFetched] = useState(false);
    const [areasFetched, setAreasFetched] = useState(false);
    const [state, setState] = useState([]);
    const [allCollegeArea, setAllCollegeArea] = useState([]);
    const [allCollegeTypes, setAllCollegeTypes] = useState([]);
    const [allCollegeCourses, setAllCollegeCourses] = useState([]);
    const [allCollegeList, setAllCollegeList] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const debouncedSearchValue = useDebounce(searchValue, 300);
    const debouncedDistrictValue = useDebounce(searchDistrictValue, 300);
    const [limit, setLimit] = useState();
    const [offset, setOffset] = useState();
    const [stream, setStream] = useState([]);
    const [priorityColleges, setPriorityColleges] = useState([]);
    const [featuredColleges, setFeaturedColleges] = useState([]);
    const [mainColleges, setMainColleges] = useState([]);
    const [subColleges, setSubColleges] = useState([]);
    const [articleDetails, setArticleDetails] = useState([]);
    const [trendingArticles, setTrendingArticles] = useState([]);
    const [blogData, setBlogData] = useState([]);
    const [searchBlogValue, setSearchBlogValue] = useState("");
    const [searchCategoryValue, setSearchCategoryValue] = useState("");
    const debouncedBlogSearchValue = useDebounce(searchBlogValue, 300);
    const debouncedCategorySearchValue = useDebounce(searchCategoryValue, 300);
    const showSnackbar = (message, severity) => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setOpenSnackbar(true);
    };

    // Fetch districts when component mounts

    // const fetchDistricts = async () => {
    //   try {
    //     const response = await invokeApi(
    //       config.getMyCollege + apiList.getcountrypincodemapping,
    //       {}
    //     );

    //     if (response && response.status === 200) {
    //       const indiaStates = response.data?.countries.find(
    //         (country) => country.countryName === "India"
    //       )?.states;

    //       if (indiaStates) {
    //         const selectedState = indiaStates.find(
    //           (state) => state.stateName === "Karnataka"
    //         );

    //         if (selectedState) {
    //           const districts = selectedState.districts.map(
    //             (district) => district.districtName
    //           );

    //           setDistricts(districts);
    //           setFilteredDistricts(districts);
    //           setDistrictsFetched(true);
    //         } else {
    //           console.error("Selected state not found");
    //         }
    //       } else {
    //         console.error("States for India not found");
    //       }
    //     } else {
    //       console.error("Failed to fetch data:", response);
    //     }
    //   } catch (error) {
    //     console.error("Error during data fetch:", error);
    //   }
    // };
    // // Memoize the fetchDistricts function
    // const memoizedFetchDistricts = useMemo(() => fetchDistricts, []);

    // useEffect(() => {
    //   if (!districtsFetched) {
    //     memoizedFetchDistricts();
    //   }
    // }, [districtsFetched, memoizedFetchDistricts]);

    // Fetch college suggestions based on search value
    // const getSuggestions = useCallback(async () => {
    //   if (
    //     debouncedDistrictValue.trim() !== "" ||
    //     debouncedSearchValue.trim() !== ""
    //   ) {
    //     setLoading(true);
    //     try {
    //       let params = {};
    //       let response = await invokeApi(
    //         config.getMyCollege + apiList.getalltopcolleges,
    //         params
    //       );
    //       if (response?.status >= 200 && response?.status < 300) {
    //         if (response.data.responseCode === "200") {
    //           setCollegeData(response.data.topColleges);
    //         } else {
    //           showSnackbar(
    //             "Something went wrong while getting Programs Details. Please try again later!",
    //             "error"
    //           );
    //         }
    //       } else {
    //         showSnackbar(
    //           "Something went wrong while getting Programs Details. Please try again later!",
    //           "error"
    //         );
    //       }
    //     } catch (error) {
    //       console.error("Error while fetching suggestions:", error);
    //       showSnackbar(
    //         "Something went wrong while getting Programs Details. Please try again later!",
    //         "error"
    //       );
    //     } finally {
    //       setLoading(false);
    //     }
    //   } else {
    //     setCollegeData([]);
    //   }
    // }, [debouncedDistrictValue, debouncedSearchValue]);
    const getSuggestions = useCallback(async () => {
        if (debouncedSearchValue.trim() !== "") {
            setLoading(true);
            try {
                let params = {};
                let response = await invokeApi(
                    config.getMyCollege + apiList.getalltopcolleges,
                    params
                );
                if (response?.status >= 200 && response?.status < 300) {
                    if (response.data.responseCode === "200") {
                        setCollegeData(response.data.topColleges);
                    } else {
                        showSnackbar(
                            "Something went wrong while getting Programs Details. Please try again later!",
                            "error"
                        );
                    }
                } else {
                    showSnackbar(
                        "Something went wrong while getting Programs Details. Please try again later!",
                        "error"
                    );
                }
            } catch (error) {
                console.error("Error while fetching suggestions:", error);
                showSnackbar(
                    "Something went wrong while getting Programs Details. Please try again later!",
                    "error"
                );
            } finally {
                setLoading(false);
            }
        } else {
            setCollegeData([]);
        }
    }, [debouncedSearchValue]);
    useEffect(() => {
        getSuggestions();
    }, [debouncedSearchValue, getSuggestions]);

    //get priority colleges
    const getprioritizedCollege = async () => {
        try {
            let params = {};
            let response = await invokeApi(
                config.getMyCollege + apiList.getPriorityColleges,
                params
            );
            if (response?.status >= 200 && response?.status < 300) {
                if (response.data.responseCode === "200") {
                    const colleges = response.data.priorityColleges;
                    setPriorityColleges(colleges);
                } else {
                    showSnackbar(
                        "Something went wrong while getting Programs Details. Please try again later!",
                        "error"
                    );
                }
            } else {
                showSnackbar(
                    "Something went wrong while getting Programs Details. Please try again later!",
                    "error"
                );
            }
        } catch (error) {
            console.error("Error fetching top colleges:", error);
            showSnackbar(
                "Something went wrong while getting Programs Details. Please try again later!",
                "error"
            );
        }
    };

    // Fetch college areas when component mounts
    // useEffect(() => {
    //   if (!areasFetched) {
    //     const getCollegeAreas = async () => {
    //       try {
    //         let params = {};
    //         let response = await invokeApi(
    //           config.getMyCollege + apiList.collegearea,
    //           params
    //         );
    //         if (response?.status >= 200 && response?.status < 300) {
    //           if (response.data.responseCode === "200") {
    //             setCollegeAreas(response.data.areas);
    //             setAreasFetched(true);
    //           } else {
    //             throw new Error("Something went wrong while getting areas.");
    //           }
    //         } else {
    //           throw new Error("Failed to fetch areas.");
    //         }
    //       } catch (error) {
    //         console.error("Error while fetching areas:", error);
    //       }
    //     };
    //     getCollegeAreas();
    //   }
    // }, [areasFetched]);

    // Fetch top college types when component mounts

    const getAllTopCollegesTypes = async () => {
        try {
            let params = {};
            let response = await invokeApi(
                config.getMyCollege + apiList.getalltopcollegestypes,
                params
            );
            if (response?.status >= 200 && response?.status < 300) {
                if (response.data.responseCode === "200") {
                    const topCollegestypes = response.data.collegeTypes;
                    setAllTopCollegeType(topCollegestypes);
                } else {
                    showSnackbar(
                        "Something went wrong while getting Programs Details. Please try again later!",
                        "error"
                    );
                }
            } else {
                showSnackbar(
                    "Something went wrong while getting Programs Details. Please try again later!",
                    "error"
                );
            }
        } catch (error) {
            console.error("Error fetching top colleges:", error);
            showSnackbar(
                "Something went wrong while getting Programs Details. Please try again later!",
                "error"
            );
        }
    };

    //top college type
    const getStream = async () => {
        try {
            let params = {};
            let response = await invokeApi(
                config.getMyCollege + apiList.getAllCollegeTypes,
                params
            );
            if (response?.status >= 200 && response?.status < 300) {
                if (response.data.responseCode === "200") {
                    const topCollegestype = response.data.collegeTypes;
                    console.log(topCollegestype);
                    setStream(topCollegestype);
                } else {
                    showSnackbar(
                        "Something went wrong while getting Programs Details. Please try again later!",
                        "error"
                    );
                }
            } else {
                showSnackbar(
                    "Something went wrong while getting Programs Details. Please try again later!",
                    "error"
                );
            }
        } catch (error) {
            console.error("Error fetching top colleges:", error);
            showSnackbar(
                "Something went wrong while getting Programs Details. Please try again later!",
                "error"
            );
        }
    };
    // Fetch top colleges details when component mounts
    const getAllTopCollegesDetails = async (offset, limit) => {
        try {
            let params = {
                offset: offset,
                limit: limit,
            };
            let response = await invokeApi(
                config.getMyCollege + apiList.getalltopcolleges,
                params
            );
            if (response?.status >= 200 && response?.status < 300) {
                if (response.data.responseCode === "200") {
                    const topCollegesone = response.data.topColleges;
                    setAllTopCollegeOne(topCollegesone);
                } else {
                    showSnackbar(
                        "Something went wrong while getting Programs Details. Please try again later!",
                        "error"
                    );
                }
            } else {
                showSnackbar(
                    "Something went wrong while getting Programs Details. Please try again later!",
                    "error"
                );
            }
        } catch (error) {
            console.error("Error fetching top colleges:", error);
            showSnackbar(
                "Something went wrong while getting Programs Details. Please try again later!",
                "error"
            );
        }
    };
    // Fetch top colleges based on selected college type

    const getAllTopColleges = async (offset, limit) => {
        try {
            let params = {
                collegeType: selectedCollegeType,
                offset: offset,
                limit: limit,
            };
            let response = await invokeApi(
                config.getMyCollege + apiList.getalltopcolleges,
                params
            );
            if (response?.status >= 200 && response?.status < 300) {
                if (response.data.responseCode === "200") {
                    console.log(response.data.topColleges);
                    const topColleges = response.data.topColleges;
                    setAllTopCollege(topColleges);
                    console.log(topColleges);
                } else {
                    alert(
                        "Something went wrong while getting Programs Details. Please try again later!"
                    );
                }
            } else {
                alert(
                    "Something went wrong while getting Programs Details. Please try again later!!"
                );
            }
        } catch (error) {
            console.error("Error fetching top colleges:", error);
            alert(
                "Something went wrong while getting Programs Details. Please try again later!!"
            );
        }
    };
    // Fetch top courses when component mounts
    const getAllTopCourses = async () => {
        try {
            let params = {};
            let response = await invokeApi(
                config.getMyCollege + apiList.exploreCourse,
                params
            );

            if (response?.status >= 200 && response?.status < 300) {
                if (response.data.responseCode === "200") {
                    setAllTopCourse(response.data.collegeCourses);
                } else {
                    showSnackbar(
                        "Something went wrong. Please try again later.",
                        "error"
                    );
                }
            } else {
                showSnackbar("Something went wrong. Please try again later.", "error");
            }
        } catch (error) {
            console.error("Error fetching top courses:", error);
            showSnackbar("Something went wrong. Please try again later.", "error");
        }
    };

    const addLead = async (id) => {
        try {
            let params = {
                collegeId: id,
                name,
                phone,
                email: "test0@gmail.com",
                course,
                leadType: "GetMyCollege",
                leadFlag,
            };

            let response = await invokeApi(
                config.getMyCollege + apiList.addLead,
                params
            );

            if (response?.status >= 200 && response?.status < 300) {
                if (response.data.responseCode === "200") {
                    setName("");
                    setEmail("");
                    setPhone("");

                    setCourse("");
                } else {
                    showSnackbar(
                        "Something went wrong. Please try again later!",
                        "error"
                    );
                }
            } else {
                showSnackbar("Something went wrong. Please try again later!", "error");
            }
        } catch (error) {
            console.error("Error adding lead:", error);
            showSnackbar("Something went wrong. Please try again later!", "error");
        }
    };

    // Fetch college data by ogUrl when component mounts or ogUrl changes

    const getCollegeByOgUrl = async () => {
        try {
            let params = {
                ogUrl: ogUrl,
            };

            let response = await invokeApi(
                config.getMyCollege + apiList.getCollegeByOgUrl,
                params
            );

            if (response?.status >= 200 && response?.status < 300) {
                if (response.data.responseCode === "200") {
                    const collegeData = response.data.colleges;

                    setCollegeInfo(collegeData);
                    setDistrict(collegeData.districts);
                    setCollegeAmenities(collegeData.collegeAmenities);
                    setCollegePlacement(collegeData.collegePlacement);
                    setCollegeCourse(collegeData.collegeCourse);
                    setCollegeGallery(collegeData.collegeGallery);
                    console.log(collegeData.collegeCourse);
                } else {
                    throw new Error("Failed to fetch college data");
                }
            } else {
                throw new Error("Failed to fetch college data");
            }
        } catch (error) {
            console.error("Error fetching college data:", error);
            alert(
                "Something went wrong while fetching college data. Please try again later!"
            );
        }
    };

    // // Fetch explore near colleges based on selected college type
    // useEffect(() => {
    //   const exploreNearColleges = async () => {
    //     try {
    //       let params = {
    //         offset: 0,
    //         limit: 10,
    //       };
    //       let response = await invokeApi(
    //         config.getMyCollege + apiList.getalltopcolleges,
    //         params
    //       );
    //       if (response?.status >= 200 && response?.status < 300) {
    //         if (response.data.responseCode === "200") {
    //           const topColleges = response.data.topColleges;
    //           setExploreNearColleges(topColleges);
    //         } else {
    //           showSnackbar(
    //             "Something went wrong while getting Programs Details. Please try again later!",
    //             "error"
    //           );
    //         }
    //       } else {
    //         showSnackbar(
    //           "Something went wrong while getting Programs Details. Please try again later!",
    //           "error"
    //         );
    //       }
    //     } catch (error) {
    //       console.error("Error fetching top colleges:", error);
    //       showSnackbar(
    //         "Something went wrong while getting Programs Details. Please try again later!",
    //         "error"
    //       );
    //     }
    //   };
    //   exploreNearColleges();
    // }, []);

    //all college area

    const getAllTopCollegesArea = async () => {
        try {
            let params = {};
            let response = await invokeApi(
                config.getMyCollege + apiList.getAllCollegeAreas,
                params
            );
            if (response?.status >= 200 && response?.status < 300) {
                if (response.data.responseCode === "200") {
                    const getAllCollegeArea = response.data.areas;
                    setAllCollegeArea(getAllCollegeArea);
                } else {
                    showSnackbar(
                        "Something went wrong while getting Programs Details. Please try again later!",
                        "error"
                    );
                }
            } else {
                showSnackbar(
                    "Something went wrong while getting Programs Details. Please try again later!",
                    "error"
                );
            }
        } catch (error) {
            console.error("Error fetching top colleges:", error);
            showSnackbar(
                "Something went wrong while getting Programs Details. Please try again later!",
                "error"
            );
        }
    };

    //all college area
    // useEffect(() => {
    //   const getAllTopCollegesTypes = async () => {
    //     try {
    //       let params = {};
    //       let response = await invokeApi(
    //         config.getMyCollege + apiList.getAllCollegeTypes,
    //         params
    //       );
    //       if (response?.status >= 200 && response?.status < 300) {
    //         if (response.data.responseCode === "200") {
    //           const getAllCollegeTypes = response.data.collegeTypes;
    //           setAllCollegeTypes(getAllCollegeTypes);
    //         } else {
    //           showSnackbar(
    //             "Something went wrong while getting Programs Details. Please try again later!",
    //             "error"
    //           );
    //         }
    //       } else {
    //         showSnackbar(
    //           "Something went wrong while getting Programs Details. Please try again later!",
    //           "error"
    //         );
    //       }
    //     } catch (error) {
    //       console.error("Error fetching top colleges:", error);
    //       showSnackbar(
    //         "Something went wrong while getting Programs Details. Please try again later!",
    //         "error"
    //       );
    //     }
    //   };
    //   getAllTopCollegesTypes();
    // }, []);
    //all college Course

    const getAllTopCollegesCourses = async () => {
        try {
            let params = {};
            let response = await invokeApi(
                config.getMyCollege + apiList.getAllCollegeCourses,
                params
            );
            if (response?.status >= 200 && response?.status < 300) {
                if (response.data.responseCode === "200") {
                    const getAllCollegeCourses = response.data.collegeCourses;
                    setAllCollegeCourses(getAllCollegeCourses);
                } else {
                    showSnackbar(
                        "Something went wrong while getting Programs Details. Please try again later!",
                        "error"
                    );
                }
            } else {
                showSnackbar(
                    "Something went wrong while getting Programs Details. Please try again later!",
                    "error"
                );
            }
        } catch (error) {
            console.error("Error fetching top colleges:", error);
            showSnackbar(
                "Something went wrong while getting Programs Details. Please try again later!",
                "error"
            );
        }
    };

    // CollegeList

    const getAllTopCollegesList = async (page, newOffset, limit) => {
        try {
            const newOffset = (page - 1) * limit;
            const params = {
                offset: newOffset,
                limit: limit,
            };

            const response = await invokeApi(
                config.getMyCollege + apiList.getalltopcolleges,
                params
            );

            if (response?.status >= 200 && response?.status < 300) {
                if (response.data.responseCode === "200") {
                    const allTopCollegeList = response.data.topColleges;
                    setAllCollegeList(allTopCollegeList);
                    setTotalPages(Math.ceil(allTopCollegeList.length / limit));
                    setOffset(newOffset);
                } else {
                    showSnackbar(
                        "Something went wrong while getting Programs Details. Please try again later!",
                        "error"
                    );
                }
            } else {
                showSnackbar(
                    "Something went wrong while getting Programs Details. Please try again later!",
                    "error"
                );
            }
        } catch (error) {
            console.error("Error fetching top colleges:", error);
            showSnackbar(
                "Something went wrong while getting Programs Details. Please try again later!",
                "error"
            );
        }
    };

    //Featured Colleges

    const getFeaturedColleges = async (offset, limit) => {
        try {
            let params = {
                // collegeType: selectedCollegeType,
                // offset: offset,
                // limit: limit,
            };
            let response = await invokeApi(
                config.getMyCollege + apiList.featuredColleges,
                params
            );
            if (response?.status >= 200 && response?.status < 300) {
                if (response.data.responseCode === "200") {
                    console.log(response.data.featuredColleges);
                    const topColleges = response.data.featuredColleges;
                    setFeaturedColleges(topColleges);
                    console.log(topColleges);
                } else {
                    alert(
                        "Something went wrong while getting Programs Details. Please try again later!"
                    );
                }
            } else {
                alert(
                    "Something went wrong while getting Programs Details. Please try again later!!"
                );
            }
        } catch (error) {
            console.error("Error fetching top colleges:", error);
            alert(
                "Something went wrong while getting Programs Details. Please try again later!!"
            );
        }
    };
    const mainCollegesByOgUrl = async () => {
        try {
            let params = {
                ogUrl: ogUrl,
                // offset: offset,
                // limit: limit,
            };
            let response = await invokeApi(
                config.getMyCollege + apiList.mainCollegesByOgUrl,
                params
            );
            if (response?.status >= 200 && response?.status < 300) {
                if (response.data.responseCode === "200") {
                    console.log(response.data.mainColleges);
                    const topColleges = response.data.mainColleges;
                    setMainColleges(topColleges);
                    const subColleges = response.data.mainColleges[0].subColleges;
                    setSubColleges(subColleges);
                    console.log(subColleges);
                } else {
                    // alert(
                    //   "Something went wrong while getting Programs Details. Please try again later!"
                    // );
                }
            } else {
                // alert(
                //   "Something went wrong while getting Programs Details. Please try again later!!"
                // );
            }
        } catch (error) {
            console.error("Error fetching top colleges:", error);
            // alert(
            //   "Something went wrong while getting Programs Details. Please try again later!!"
            // );
        }
    };
    const getArticle = async () => {
        try {
            let params = {};
            let response = await invokeApi(
                config.getMyCollege + apiList.getArticles,
                params
            );
            if (response?.status >= 200 && response?.status < 300) {
                if (response.data.responseCode === "200") {
                    const article = response.data.blogs;
                    setArticleDetails(article);
                } else {
                    showSnackbar(
                        "Something went wrong while getting Programs Details. Please try again later!",
                        "error"
                    );
                }
            } else {
                showSnackbar(
                    "Something went wrong while getting Programs Details. Please try again later!",
                    "error"
                );
            }
        } catch (error) {
            console.error("Error fetching top colleges:", error);
            showSnackbar(
                "Something went wrong while getting Programs Details. Please try again later!",
                "error"
            );
        }
    };
    const getBlogSuggestions = useCallback(async () => {
        if (
            debouncedBlogSearchValue.trim() !== "" ||
            debouncedCategorySearchValue.trim() !== ""
        ) {
            setLoading(true);
            try {
                let params = {};
                let response = await invokeApi(
                    config.getMyCollege + apiList.getArticles,
                    params
                );
                if (response?.status >= 200 && response?.status < 300) {
                    if (response.data.responseCode === "200") {
                        setBlogData(response.data.blogs);
                    } else {
                        showSnackbar(
                            "Something went wrong while getting Programs Details. Please try again later!",
                            "error"
                        );
                    }
                } else {
                    showSnackbar(
                        "Something went wrong while getting Programs Details. Please try again later!",
                        "error"
                    );
                }
            } catch (error) {
                console.error("Error while fetching suggestions:", error);
                showSnackbar(
                    "Something went wrong while getting Programs Details. Please try again later!",
                    "error"
                );
            } finally {
                setLoading(false);
            }
        } else {
            setBlogData([]);
        }
    }, [debouncedBlogSearchValue, debouncedCategorySearchValue]);

    useEffect(() => {
        getBlogSuggestions();
    }, [debouncedBlogSearchValue, debouncedCategorySearchValue, getBlogSuggestions]);


    const getArticleByOgUrl = async () => {
        try {
            let params = {
                ogUrl: ogUrl,
            };
            let response = await invokeApi(
                config.getMyCollege + apiList.getArticleByOgUrl,
                params
            );
            if (response?.status >= 200 && response?.status < 300) {
                if (response.data.responseCode === "200") {
                    const article = response.data.blog;
                    setTrendingArticles(article);
                    console.log(article);
                } else {
                    showSnackbar(
                        "Something went wrong while getting Programs Details. Please try again later!",
                        "error"
                    );
                }
            } else {
                showSnackbar(
                    "Something went wrong while getting Programs Details. Please try again later!",
                    "error"
                );
            }
        } catch (error) {
            console.error("Error fetching top colleges:", error);
            showSnackbar(
                "Something went wrong while getting Programs Details. Please try again later!",
                "error"
            );
        }
    };
    return {
        loading,
        district,
        filteredDistricts,
        collegeData,
        searchValue,
        blogData,
        searchBlogValue,
        searchCategoryValue,
        searchDistrictValue,
        exploreNearColleges,
        areas,
        allTopCollegeTypes,
        allTopCollege,
        allTopCollegeOne,
        selectedCollegeType,
        allTopCourse,
        openSnackbar,
        snackbarMessage,
        snackbarSeverity,
        name,
        phone,
        email,
        qualification,
        course,
        collegeInfo,
        collegeCourse,
        collegeAmenities,
        collegePlacement,
        collegeGallery,
        ogUrl,
        state,
        allCollegeArea,
        stream,
        allCollegeCourses,
        allCollegeList,
        totalPages,
        currentPage,
        offset,
        limit,
        priorityColleges,
        featuredColleges,
        mainColleges,
        subColleges,
        articleDetails,
        trendingArticles,
        getArticleByOgUrl,
        getArticle,
        setLimit,
        setOffset,
        setDistrict,
        getAllTopColleges,
        addLead,
        getAllTopCollegesTypes,
        getAllTopCollegesDetails,
        getAllTopCourses,
        getAllTopCollegesList,
        getCollegeByOgUrl,
        getAllTopCollegesArea,
        getAllTopCollegesCourses,
        getStream,
        getprioritizedCollege,
        setSearchValue,
        setSearchBlogValue,
        setSearchCategoryValue,
        setSearchDistrictValue,
        setLoading,
        setFilteredDistricts,
        setCollegeAreas,
        setSelectedCollegeType,
        setName,
        setCourse,
        setPhone,
        setEmail,
        setQualification,
        setOpenSnackbar,
        setSubmitClicked,
        setCurrentPage,
        getFeaturedColleges,
        mainCollegesByOgUrl,
    };
};

export default useFetch;
